import rest from '@/api/rest';


async function index(user, device, options) {
  const response = await rest.get('/admin/events', {user, diode: device, ...options});
  return response.events;
}

async function last(user, device) {
  const response = await rest.get('/admin/events', {user, diode: device, after: -1});
  if (Array.isArray(response.events) && response.events.length) {
    return response.events[0].ingested;
  }
  return null;
}

export default {
  index,
  last
};
